import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../../Helpers";
import {deserializeEcgMeasurement, ECG} from "../../../patient/measurement/ECG";
import {deserializeMeasurementEcgTrigger, deserializePatientTrigger, MeasurementEcgTrigger, PatientTrigger} from "../../../Trigger";
import {deserializePatientTriggerEvent, PatientTriggerEvent} from "../../PatientTriggerEvent";

type EventType = 'classification' | 'control_alarm';

  interface EcgTriggerEvent extends DeserializedRecord {
    eventType: EventType;
    patientTriggerValueType: "ecg" ;
    phone: string;
    patientMeasurementEcg: ECG,
    patientTrigger: PatientTrigger,
    patientMeasurementEcgTrigger: MeasurementEcgTrigger,
    patientTriggerEvent: PatientTriggerEvent,
  }

  interface EventData extends JSONAPIRecord {
    relationships: {
      patient_measurement_ecg: JSONAPISingleRelationship,
      patient_measurement_ecg_trigger: JSONAPISingleRelationship,
      patient_trigger: JSONAPISingleRelationship,
      patient_trigger_event: JSONAPISingleRelationship
    }
  }

const deserializeEcgTriggerEvent: Deserializer<EcgTriggerEvent, EventData> = (data, included) => {
  const patientMeasurementEcg = deserializeSingleRelationship<ECG>(data.relationships.patient_measurement_ecg, included, deserializeEcgMeasurement);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger, included, deserializePatientTrigger);

  const patientMeasurementEcgTrigger = deserializeSingleRelationship<MeasurementEcgTrigger>(
    data.relationships.patient_measurement_ecg_trigger, included, deserializeMeasurementEcgTrigger);

  // eslint-disable-next-line @stylistic/max-len
  const patientTriggerEvent = deserializeSingleRelationship<PatientTriggerEvent>(data.relationships.patient_trigger_event, included, deserializePatientTriggerEvent);

  return {
    ...deserializeItem(data),
    patientMeasurementEcg,
    patientTrigger,
    patientTriggerEvent,
    patientMeasurementEcgTrigger
  };
};

const deserializeEcgTriggerEventWithoutTriggerEvent: Deserializer<EcgTriggerEvent, EventData> = (data, included) => {
  const patientMeasurement = deserializeSingleRelationship<ECG>(data.relationships.patient_measurement_ecg, included, deserializeEcgMeasurement);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger, included, deserializePatientTrigger);

  return {
    ...deserializeItem(data),
    patientMeasurement,
    patientTrigger
  };
};

export {deserializeEcgTriggerEvent, deserializeEcgTriggerEventWithoutTriggerEvent, EcgTriggerEvent};

